import * as Constants from './constants';
import { BaseLinkPreviewObject } from './BaseLinkPreviewObject';
import { rehydrateWebPageLinkPreview } from './WebpageLinkPreviewObject';
import { rehydrateVideoLinkPreview } from './VideoLinkPreviewObject';

export default async function rehydrateLinkPreview(
    div: HTMLDivElement
): Promise<BaseLinkPreviewObject> {
    if (div.id.indexOf(Constants.LINK_PREVIEW_BORDER_ID_BASE) === 0) {
        let previewType = getPreviewType(div.id);
        switch (previewType) {
            case Constants.LINK_PREVIEW_BORDER_WEBPAGE_TYPE:
                return rehydrateWebPageLinkPreview(div);
            case Constants.LINK_PREVIEW_BORDER_VIDEO_TYPE:
                return rehydrateVideoLinkPreview(div);
        }
    }

    return Promise.reject('div did not match a known link preview type');
}

function getPreviewType(borderId: string): string {
    let borderParts = borderId.split('_');
    if (
        borderParts &&
        borderParts.length > 1 &&
        borderParts[1].indexOf(Constants.LINK_PREVIEW_BORDER_WEBPAGE_TYPE) === 0
    ) {
        return Constants.LINK_PREVIEW_BORDER_WEBPAGE_TYPE;
    } else if (borderParts[1].indexOf(Constants.LINK_PREVIEW_BORDER_VIDEO_TYPE) === 0) {
        return Constants.LINK_PREVIEW_BORDER_VIDEO_TYPE;
    } else {
        return null;
    }
}
